import { render, staticRenderFns } from "./norecordsComponent.vue?vue&type=template&id=e642d700&scoped=true"
import script from "./norecordsComponent.vue?vue&type=script&lang=js"
export * from "./norecordsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e642d700",
  null
  
)

export default component.exports